exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-row[data-v-ed684a1e] {\n  padding-top: 10px;\n  padding-bottom: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n.table-row.clickable[data-v-ed684a1e] {\n  cursor: pointer;\n}\n.table-row.clickable[data-v-ed684a1e]:hover {\n  background: #efefef;\n}\n.table-row.bordered[data-v-ed684a1e] {\n  border-bottom: 1px solid #efefef;\n}\n.table-column p[data-v-ed684a1e], .table-column a[data-v-ed684a1e] {\n  margin-bottom: 0px;\n}\n.table-column.centered[data-v-ed684a1e] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}", ""]);

// exports
